import { sampleOrganization } from '../Organization/SampleOrganization'
import { dateToTimestamp } from '../Timestamp'
import { GeneralMeetingType, GM } from './GM'

export const sampleGM = (withoutURL?: boolean): GM => {
  const date = new Date()
  const { id, websiteUrl } = sampleOrganization()
  const sampleGM = { date: dateToTimestamp(date), organizationId: id, type: GeneralMeetingType.annual }
  return withoutURL ? sampleGM : { ...sampleGM, proxyNoticeUrl: `${websiteUrl}/agm` }
}

export const sampleGMWithMockDates: GM = {
  ...sampleGM(),
  date: dateToTimestamp(new Date('2021-06-26T14:46:36.000')),
}
